import React, { useEffect, useState } from "react";

const Timer = ({ user, lastInvites, title, onClick }) => {
  const [minutes, setMintues] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (user && lastInvites.length > 0) {
      getInviteTime();
    } else {
      setMintues(0);
      setSeconds(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastInvites]);

  useEffect(() => {}, []);

  useEffect(() => {
    let interval;
    if (seconds === 0 && minutes > 0) {
      setMintues((m) => m - 1);
      setSeconds(59);
    } else {
      if (seconds > 0) {
        interval = setInterval(() => {
          setSeconds((prevSeconds) => prevSeconds - 1);
        }, 1000);
      } else if (seconds === 0) {
        clearInterval(interval);
      }
    }

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seconds]);

  const getInviteTime = () => {
    const lastInvite = lastInvites.find((i) => i.id === user.id);

    if (lastInvite) {
      const pendingTime =
        1800 - (new Date().getTime() - lastInvite.time) / 1000;
      if (pendingTime > 0) {
        const min = Math.floor(pendingTime / 60);
        const sec = Math.floor(pendingTime % 60);
        setMintues(min);
        setSeconds(sec);
      } else {
        setMintues(0);
        setSeconds(0);
      }
    } else {
      setMintues(0);
      setSeconds(0);
    }
  };

  return (
    <div className="hardCopyAddressEdit" onClick={() => minutes.toString().padStart(2, "0") === "00" &&
        seconds.toString().padStart(2, "0") === "00" ? onClick() : ""}>
      {minutes.toString().padStart(2, "0") === "00" &&
      seconds.toString().padStart(2, "0") === "00" ? (
        <span >{title}</span>
      ) : (
        <>
          <span style={{ color: "#9A9FA7" }}>{title + " In: "}</span>
          <span className="sendVarificationCodeFormTimerTime">
          {minutes.toString().padStart(2, "0")}:
          {seconds.toString().padStart(2, "0")}
        </span>
        </>
      )}
    </div>
  );
};

export default Timer;
